/** moderator/transcriptions — KEYS. */
export const transcriptionsKeys = {
  all: () => ['moderator', 'transcriptions'] as const,
  file: (game: string, world: string, cohort: string, match: string, filename: string) =>
    [...transcriptionsKeys.all(), 'file', game, world, cohort, match, filename] as const,
  worlds: () => [...transcriptionsKeys.all(), 'worlds'] as const,
  teams: (gameName: string | null, worldName: string | null) =>
    [...transcriptionsKeys.all(), 'teams', gameName, worldName] as const,
  matches: (gameName: string | null, worldName: string | null, cohortId: string | null) =>
    [...transcriptionsKeys.all(), 'matches', gameName, worldName, cohortId] as const,
};
